import axios from 'axios';

const requestHelper = async function request(
  svc = null,
  method = 'GET',
  data = null,
  cors = false,
  additionalHeaders = null,
) {
  let fetchObject = {
    method: method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (method === 'POST' || method === 'PUT') {
    fetchObject.body = JSON.stringify(data);
  }
  if (cors) {
    fetchObject.mode = 'cors';
  }
  if (additionalHeaders) {
    fetchObject.headers = Object.assign(fetchObject.headers, additionalHeaders);
  }
  try {
    let result = fetch(svc, fetchObject);
    let response = await result;
    response = response.clone();
    let json = await response.json();
    if (response.ok) {
      return json;
    } else {
      // updated so that timeouts return same resp structure as errors
      return {
        Msg: json.ResponseStatus.Message,
        IsError: true,
      };
      // throw new Error(json.ResponseStatus.Message);
    }
  } catch (_err) {
    return {
      Msg: _err,
      IsError: true,
    };
  }
};

/**
 * Request logic with keep-alive enabled and allow a specific timeout so
 * request doesn't spin forever.
 */
const requestWithTimeout = async (url, method = 'GET', options = {}, timeout = 8000) => {
  return axios
    .request({
      url,
      method,
      timeout,
      ...options,
    })
    .then((resp) => resp.data)
    .catch((error) => {
      console.error(error);
      return {
        IsError: true,
        Msg: error.message,
      };
    });
};

export { requestHelper, requestWithTimeout };
